import { Box, Typography, TextField, Button, useTheme, useMediaQuery} from "@mui/material";
import useSendClubeFeedback from "../../../../hooks/useSendClubeFeedback";
import { useEffect, useState } from "react";
import { useAlert } from "../../../../context/AlertContext";
import { benefits, formBg, checkIcon } from "../../../../constants/Home/feedback";
import { FormInput } from "./FormInput";
import { FlexContainer } from "../../../../styles/common/FlexBox";
import { FormContainer, MobileFormContainer, StyledBox, SubmitButton } from "./Styled";

const FeedBack = () => {
  const { sendFeedback, response, loading, error } = useSendClubeFeedback();
  const { showAlert } = useAlert();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.company) {
      showAlert("Preencha todos os campos", "warning");
      return;
    }
    await sendFeedback(formData);
  };

  useEffect(() => {
    if (response) {
      setFormData({ name: "", email: "", company: "" });
      showAlert(response, "success");
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      showAlert(error, "error");
    }
  }, [error]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box component="section" id="formulario"
        sx={{
          backgroundColor: "#fff",
          minHeight: { xs: "100vh", sm: "64vh", lg: "100vh" },
          px: 2,
          pt: { xs: 4, sm: 24, md: 16 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
      {/* TÍTULO */}
      <Typography variant="h6" fontWeight={700} textAlign="center" mb={4}
        sx={{
          color: "var(--c-brand-ink-alt)",
          fontSize: { xs: "16px", sm: "20px" },
          lineHeight: 1.4,
          maxWidth: "800px",
          mx: "auto",
        }}
      >
        <Box component="span">
          <Box component="span" sx={{ backgroundColor: "#E3C852", px: 0.5, fontWeight: "900" }}>
            PREENCHA JÁ
          </Box>
          <Box component="span" sx={{ fontWeight: "700" }}>
            o formulário abaixo e
          </Box>
          <Box component="span" sx={{ backgroundColor: "#E3C852", px: 0.5, fontWeight: "900" }}>
            VENHA
          </Box>
          <br />
        </Box>
        <Box component="span"sx={{display: { xs: "inline", sm: "block" }, fontWeight: "700", color: "var(--c-brand-ink-alt)", mt: { sm: 0.5 },}}>
          fazer parte do Clube de Benefícios para colaboradores <br />
          e clientes que mais cresce no Brasil!
        </Box>
      </Typography>

      {isMobile ? (
        <Box>
          {/* MOBILE - FORM */}
          <MobileFormContainer>
            <FormInput label="NOME" name="name" value={formData.name} onChange={handleChange}/>
            <FormInput label="EMAIL" name="email" value={formData.email} onChange={handleChange} />
            <FormInput label="EMPRESA" name="company" value={formData.company} onChange={handleChange} />

            <SubmitButton variant="contained" disabled={loading} onClick={handleSubmit}>
              {loading ? "Enviando..." : "ENVIAR"}
            </SubmitButton>
          </MobileFormContainer>

          {/* MOBILE - BENEFÍCIOS */}
          <Box sx={{width: "90%", maxWidth: 360, backgroundColor: "#F8EFC8", borderRadius: "16px", p: 3, boxShadow: 1, }}>
            <Typography variant="h6" fontWeight="700" color="var(--c-brand-ink-alt)" mb={4} sx={{ lineHeight: 1.3, textAlign: "center" }}>
              QUAIS AS VANTAGENS EM TER <br /> UM CLUBE DE BENEFÍCIOS?
            </Typography>

            {benefits.map((item, index) => (
              <Box key={index} sx={{ display: "flex", alignItems: "flex-start", mb: 2.5, gap: 1,}}>
                <Box component="img" src={checkIcon} alt="check" sx={{ width: 20, mt: "4px" }}/>
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    color: "#6E6E6E",
                    lineHeight: 1.4,
                  }}
                >
                  {item}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <StyledBox>
          {/* DESKTOP - FORM */}
          <FormContainer>
            <FormInput label="NOME" name="name" value={formData.name} onChange={handleChange}/>
            <FormInput label="EMAIL" name="email" value={formData.email} onChange={handleChange} />
            <FormInput label="EMPRESA" name="company" value={formData.company} onChange={handleChange} />
            <SubmitButton variant="contained" disabled={loading} onClick={handleSubmit}>
              {loading ? "Enviando..." : "ENVIAR"}
            </SubmitButton>
          </FormContainer>

          {/* DESKTOP - BENEFÍCIOS */}
          <Box sx={{ width: "50%", display: "flex", flexDirection: "column", justifyContent: "center", px: 3,}}>
            <Typography variant="h6" fontWeight="700" color="var(--c-brand-ink-alt)" mb={3} sx={{ lineHeight: 1.3, ml: {md: 0, sm: 2, lg: 0}}}>
              QUAIS AS VANTAGENS EM TER <br /> UM CLUBE DE BENEFÍCIOS?
            </Typography>

            {benefits.map((item, index) => (
              <Box key={index} sx={{ display: "flex", alignItems: "flex-start", mb: 1.9, gap: 1, ml: {md: 0, sm: 2, lg: 0} }}
              >
                <Box component="img" src={checkIcon} alt="check" sx={{ width: 20, mt: "4px" }}/>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#6E6E6E",
                    lineHeight: 1.4,
                  }}
                >
                  {item}
                </Typography>
              </Box>
            ))}
          </Box>
        </StyledBox>
      )}
    </Box>
  );
};
export default FeedBack;